/**
 * Q37 (ruled 2026-10-14): a division the organiser set to anything but
 * `active` (inactive, pending, archived) is closed to new entries on every
 * rail and surface. Entries already held in it stay as they are.
 *
 * `event_group.status` is NOT NULL (default 'active'), so a missing value only
 * occurs in a partial projection; it reads as open rather than closing every
 * division a caller forgot to select the column for.
 */
export function isDivisionClosed(group: { status?: string | null }): boolean {
  return group.status != null && group.status !== 'active';
}
